"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caneva": {
    "a1038016": [{
      "hkey": "d1f55afa",
      "slug": "stevena",
      "name": "Stevenà",
      "primary": true,
      "skipSearch": false
    }],
    "stavena": [{
      "hkey": "d1f55afa",
      "slug": "stevena",
      "name": "Stevenà",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "47d44b37": [{
      "hkey": "0d40cde6",
      "slug": "la-crosetta",
      "name": "La Crosetta",
      "primary": true,
      "skipSearch": false
    }],
    "crosetta-del-cansiglio": [{
      "hkey": "0d40cde6",
      "slug": "la-crosetta",
      "name": "La Crosetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "680f0386": [{
      "hkey": "b955e4fd",
      "slug": "caneva",
      "name": "Caneva",
      "primary": true,
      "skipSearch": false
    }],
    "gaiardin": [{
      "hkey": "b955e4fd",
      "slug": "caneva",
      "name": "Caneva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7ebc0cba": [{
      "hkey": "b955e4fd",
      "slug": "caneva",
      "name": "Caneva",
      "primary": true,
      "skipSearch": false
    }],
    "lama-de-carpen": [{
      "hkey": "b955e4fd",
      "slug": "caneva",
      "name": "Caneva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a523011a": [{
      "hkey": "b955e4fd",
      "slug": "caneva",
      "name": "Caneva",
      "primary": true,
      "skipSearch": false
    }],
    "malconsei": [{
      "hkey": "b955e4fd",
      "slug": "caneva",
      "name": "Caneva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7c8e947f": [{
      "hkey": "b955e4fd",
      "slug": "caneva",
      "name": "Caneva",
      "primary": true,
      "skipSearch": false
    }],
    "pradego": [{
      "hkey": "b955e4fd",
      "slug": "caneva",
      "name": "Caneva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "91dcd590": [{
      "hkey": "b955e4fd",
      "slug": "caneva",
      "name": "Caneva",
      "primary": true,
      "skipSearch": false
    }],
    "tambruz": [{
      "hkey": "b955e4fd",
      "slug": "caneva",
      "name": "Caneva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "efe39558": [{
      "hkey": "9acbae86",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-stavena": [{
      "hkey": "9acbae86",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5aa6b7a8": [{
      "hkey": "ab9d71e3",
      "slug": "sarone",
      "name": "Sarone",
      "primary": true,
      "skipSearch": false
    }],
    "sarone-fiaschetti": [{
      "hkey": "ab9d71e3",
      "slug": "sarone",
      "name": "Sarone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;